import { Avatar, Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useUnit } from "effector-react";

import images from "../constants/images";
import { $playerData, $playerProfile } from "../store";
import EXPBlock from "./ui/EXPBlock";
import FAQButton from "./ui/FAQButton";

const Header = () => {
  const [playerProfile, playerData] = useUnit([$playerProfile, $playerData]);

  return (
    <Stack
      spacing={1}
      paddingX={1.5}
      width={"100%"}
      paddingTop={11}
      position={"absolute"}
      zIndex={100}
    >
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"end"}
        justifyContent={"space-between"}
      >
        <Stack
          padding={1}
          gap={"5px"}
          width={"100%"}
          direction={"row"}
          borderRadius={"11px"}
          bgcolor="primary.light"
          boxShadow={"0px 4px 4px rgba(0, 0, 0, 0.15)"}
        >
          <Box
            width="50px"
            height="50px"
            overflow="hidden"
            minWidth={"50px"}
            border="4px solid"
            borderRadius="10px"
            bgcolor={"primary.light"}
            borderColor="primary.borderLightBlue"
          >
            <Avatar
              variant="square"
              src={images.MockAvatar}
              alt={playerProfile?.firstName}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
          <Stack justifyContent={"end"} width={"100%"} gap={"2px"}>
            <Typography fontSize={"12px"} color="primary.contrastText">
              {playerProfile?.firstName}
            </Typography>
            <Stack
              height={"28px"}
              left={"10px"}
              borderRadius={"8px"}
              bgcolor={"primary.dark"}
              minWidth={"100px"}
              maxWidth={"fit-content"}
              position={"relative"}
              display={"flex"}
              alignItems={"end"}
              justifyContent={"center"}
              pr={1}
              border={"2px solid"}
              borderColor={"primary.darkBorder"}
            >
              <Box
                height={"35px"}
                width={"35px"}
                position={"absolute"}
                left={-15}
                bottom={-5}
              >
                <img
                  src={images.icons.TCoin}
                  alt={"TCoin"}
                  style={{ width: "100%", height: "100%" }}
                />
              </Box>

              <Typography color="primary.contrastText" pl={5}>
                {playerData?.player_resources?.["resource/token"]?.toFixed(8) ||
                  0}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction={"row"} gap={2} alignItems={"center"}>
        <EXPBlock title={"TV mined"} value={110349} maxValue={21000000} />
        <FAQButton />
      </Stack>
    </Stack>
  );
};

export default Header;
